import AsyncStorage from '@react-native-async-storage/async-storage';

import { logError } from './sentry/sentry';

const setItem = async (key: string, value: string): Promise<void> => {
  try {
    await AsyncStorage.setItem(key, value);
  } catch (error) {
    logError({
      message: `Error setting item with key "${key}":  Error"${error}`,
      category: 'async-storage',
    });
  }
};

const getItem = async (key: string): Promise<string | null> => {
  try {
    return await AsyncStorage.getItem(key);
  } catch (error) {
    logError({
      message: `Error getting item with key "${key}":  Error"${error}`,
      category: 'async-storage',
    });
    return null;
  }
};

const removeItem = async (key: string): Promise<void> => {
  try {
    await AsyncStorage.removeItem(key);
  } catch (error) {
    logError({
      message: `Error removing item with key "${key}":  Error"${error}`,
      category: 'async-storage',
    });
  }
};

export { getItem, removeItem, setItem };
